import { render, staticRenderFns } from "./SuppliersGroupsList.vue?vue&type=template&id=4d373cb5&"
import script from "./SuppliersGroupsList.vue?vue&type=script&lang=js&"
export * from "./SuppliersGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports